import { Heading } from 'grommet'
import React from 'react'

// TODO: logo
export const Logo: React.FC = () => <Heading level="3">.vadistic</Heading>
